<div class="card-container">
  <img
    class="card-img-small"
    src="../../../../../assets/images/Payment Method/Visa.png"
    alt=""
    [ngClass]="{
          'card-active': flashPaymentService.controller.paymentMethod === 'V',
          '': flashPaymentService.controller.paymentMethod !== 'V'
        }"
  />
  <img
    class="card-img-small"
    src="../../../../../assets/images/Payment Method/Mastercard.png"
    alt=""
    [ngClass]="{
          'card-active': flashPaymentService.controller.paymentMethod === 'M',
          '': flashPaymentService.controller.paymentMethod !== 'M'
        }"
  />
  <img
    class="card-img-small"
    src="../../../../../assets/images/Payment Method/Amex.png"
    alt=""
    [ngClass]="{
          'card-active': flashPaymentService.controller.paymentMethod === 'X',
          '': flashPaymentService.controller.paymentMethod !== 'X'
        }"
  />
  <img
    class="card-img-small"
    src="../../../../../assets/images/Payment Method/ath.png"
    alt=""
    [ngClass]="{
          'card-active': flashPaymentService.controller.paymentMethod === 'A',
          '': flashPaymentService.controller.paymentMethod !== 'A'
        }"
  />
</div>
